/**
 * Exit Intent Popup JavaScript
 * Detects mouse leaving viewport (desktop only) and shows a lead capture popup.
 * On submit: pushes to HubSpot, triggers PDF download.
 */

(function() {
  'use strict';
  console.log('[Exit Popup] Script loaded');

  var CONFIG = {
    API_BASE_URL: 'https://main-inbound-automation.vercel.app/api/contact',
    BRAND: 'zengaz',
    ARM_DELAY_MS: 3000,
    SUPPRESS_DAYS: 3,
    STORAGE_KEY: 'exitPopupLastShown',
  };

  var ExitPopupManager = {
    state: {
      armed: false,
      shown: false,
      userType: null,
    },

    $(id) {
      return document.getElementById(id);
    },

    capitalize: function(str) {
      if (!str) return '';
      return str.replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    },

    init: function() {
      console.log('[Exit Popup] init() called');
      console.log('[Exit Popup] overlay element:', this.$('exit-popup-overlay'));
      console.log('[Exit Popup] form view element:', this.$('exit-popup-form-view'));
      console.log('[Exit Popup] success view element:', this.$('exit-popup-success-view'));
      this.loadCountries();
      this.setupExitIntent();
      this.setupEventListeners();
      this.setupNameCapitalization();
      console.log('[Exit Popup] init() complete');
    },

    isSuppressed: function() {
      try {
        var lastShown = localStorage.getItem(CONFIG.STORAGE_KEY);
        if (!lastShown) return false;
        var elapsed = Date.now() - parseInt(lastShown, 10);
        return elapsed < CONFIG.SUPPRESS_DAYS * 24 * 60 * 60 * 1000;
      } catch (e) {
        return false;
      }
    },

    markShown: function() {
      try {
        localStorage.setItem(CONFIG.STORAGE_KEY, Date.now().toString());
      } catch (e) {}
    },

    setupExitIntent: function() {
      var self = this;

      if (this.isSuppressed()) {
        console.log('[Exit Popup] Suppressed — shown within last', CONFIG.SUPPRESS_DAYS, 'days');
        return;
      }

      console.log('[Exit Popup] setupExitIntent() — arming in', CONFIG.ARM_DELAY_MS, 'ms');

      // Arm after delay to avoid false triggers on page load
      setTimeout(function() {
        self.state.armed = true;
        console.log('[Exit Popup] NOW ARMED — move mouse to top of viewport to trigger');
      }, CONFIG.ARM_DELAY_MS);

      document.documentElement.addEventListener('mouseleave', function(e) {
        console.log('[Exit Popup] mouseleave fired — clientY:', e.clientY, 'armed:', self.state.armed, 'shown:', self.state.shown);
        if (!self.state.armed || self.state.shown) {
          console.log('[Exit Popup] BLOCKED — armed:', self.state.armed, 'shown:', self.state.shown);
          return;
        }
        if (e.clientY > 0) {
          console.log('[Exit Popup] BLOCKED — clientY > 0 (mouse left from side/bottom)');
          return;
        }

        // Don't show if prize popup or sample popup is visible
        var prizePopup = document.getElementById('zengaz-popup-overlay');
        if (prizePopup && prizePopup.style.display === 'flex') {
          console.log('[Exit Popup] BLOCKED — prize popup is visible');
          return;
        }
        var samplePopup = document.getElementById('sample-popup-overlay');
        if (samplePopup && samplePopup.style.display === 'flex') {
          console.log('[Exit Popup] BLOCKED — sample popup is visible');
          return;
        }

        console.log('[Exit Popup] ALL CHECKS PASSED — calling showPopup()');
        self.showPopup();
      });
    },

    loadCountries: function() {
      var countrySelect = this.$('exitCountry');
      if (!countrySelect) return;

      var countries = [
        'Afghanistan', 'Albania', 'Antarctica', 'Åland Islands', 'Algeria', 'American Samoa',
        'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Aruba', 'Asia/Pacific Region',
        'Azerbaijan', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Bahamas', 'Bahrain',
        'Bangladesh', 'Barbados', 'Belgium', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina',
        'Botswana', 'Bouvet Island', 'Brazil', 'Caribbean Netherlands', 'Belize', 'Solomon Islands',
        'Brunei', 'Bulgaria', 'Burundi', 'Belarus', 'Bermuda', 'Cambodia', 'Cayman Islands',
        'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Cuba', 'Curaçao',
        'Sri Lanka', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands',
        'Colombia', 'Comoros', 'Congo', 'Democratic Republic of the Congo', 'Cook Islands',
        'Costa Rica', 'Croatia', 'Cyprus', 'Czech Republic', 'Benin', 'Denmark', 'Dominica',
        'Dominican Republic', 'Ecuador', 'El Salvador', 'Equatorial Guinea', 'Ethiopia',
        'Eritrea', 'Estonia', 'Europe', 'South Georgia and the South Sandwich Islands', 'Fiji',
        'Finland', 'France', 'Falkland Islands', 'Faroe Islands', 'French Polynesia',
        'French Southern and Antarctic Lands', 'Djibouti', 'Gabon', 'Georgia', 'Gambia',
        'Germany', 'Ghana', 'Greenland', 'Guadeloupe', 'Guernsey', 'Kiribati', 'Greece',
        'Grenada', 'Guam', 'Guatemala', 'Guinea', 'Guyana', 'French Guiana', 'Gibraltar',
        'Haiti', 'Heard Island and McDonald Islands', 'Vatican City', 'Honduras', 'Hungary',
        'Hong Kong', 'Isle of Man', 'Iran', 'Jersey', 'Macau', 'Martinique', 'Montserrat',
        'Myanmar (Burma)', 'North Korea', 'Palestine', 'Puerto Rico', 'Réunion',
        'Saint Barthélemy', 'Saint Martin', 'Sint Maarten', 'South Sudan', 'Sudan', 'Syria',
        'Taiwan', 'Turks and Caicos Islands', 'U.S. Virgin Islands', 'Iceland', 'India',
        'Indonesia', 'Iraq', 'Ireland', 'Israel', 'Italy', 'British Indian Ocean Territory',
        "Cote d'Ivoire", 'Jamaica', 'Japan', 'Kazakhstan', 'Jordan', 'Kenya', 'South Korea',
        'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Lebanon', 'Lesotho', 'Latvia', 'Liberia',
        'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia',
        'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Monaco',
        'Mongolia', 'Moldova', 'Montenegro', 'Morocco', 'Mozambique', 'Oman', 'Namibia', 'Nauru',
        'Nepal', 'Netherlands', 'New Caledonia', 'Vanuatu', 'Netherlands Antilles', 'New Zealand',
        'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Norway',
        'Northern Mariana Islands', 'United States Minor Outlying Islands', 'Micronesia',
        'Marshall Islands', 'Palau', 'Pakistan', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru',
        'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Guinea-Bissau', 'East Timor',
        'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Helena', 'Saint Kitts and Nevis',
        'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines',
        'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Svalbard and Jan Mayen',
        'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Vietnam',
        'Western Sahara', 'Slovenia', 'Somalia', 'South Africa', 'Zimbabwe', 'Spain', 'Suriname',
        'Swaziland', 'Sweden', 'Switzerland', 'Tajikistan', 'Thailand', 'Togo', 'Tokelau',
        'Tonga', 'Trinidad and Tobago', 'United Arab Emirates', 'Tunisia', 'Türkiye',
        'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'Macedonia (FYROM)', 'Egypt',
        'United Kingdom', 'Tanzania', 'United States', 'Burkina Faso', 'Uruguay', 'Uzbekistan',
        'Venezuela', 'British Virgin Islands', 'Wallis and Futuna', 'Samoa', 'Yemen', 'Zambia',
        'Canary Islands',
      ];

      countries.sort();

      countries.forEach(function(country) {
        var option = document.createElement('option');
        option.value = country;
        option.textContent = country;
        countrySelect.appendChild(option);
      });
    },

    setupEventListeners: function() {
      var self = this;
      var closeBtn = this.$('exit-popup-close-btn');
      var overlay = this.$('exit-popup-overlay');
      var form = this.$('exit-popup-form');
      var successCloseBtn = this.$('exit-popup-success-close-btn');

      if (closeBtn) closeBtn.addEventListener('click', function() { self.hidePopup(); });
      if (successCloseBtn) successCloseBtn.addEventListener('click', function() { self.hidePopup(); });

      if (overlay) {
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) self.hidePopup();
        });
      }

      // User type selection
      var radios = document.querySelectorAll('input[name="exit_user_type"]');
      radios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          self.state.userType = radio.value;
          var err = self.$('exit-popup-type-error');
          if (err) err.style.display = 'none';
        });
      });

      if (form) {
        form.addEventListener('submit', function(e) { self.handleSubmit(e); });

        // Blur validation
        var inputs = form.querySelectorAll('.exit-popup-input');
        inputs.forEach(function(input) {
          input.addEventListener('blur', function() {
            var label = input.previousElementSibling;
            if (!input.value || !input.value.trim()) {
              input.classList.add('is-invalid');
              if (label) label.classList.add('is-invalid');
            } else {
              input.classList.remove('is-invalid');
              if (label) label.classList.remove('is-invalid');
            }
            if (input.id === 'exitEmail' && input.value && input.value.trim()) {
              var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!re.test(input.value)) {
                input.classList.add('is-invalid');
                if (label) label.classList.add('is-invalid');
              }
            }
          });

          input.addEventListener('input', function() {
            if (input.classList.contains('is-invalid') && input.value && input.value.trim()) {
              input.classList.remove('is-invalid');
              var label = input.previousElementSibling;
              if (label) label.classList.remove('is-invalid');
            }
          });
        });
      }
    },

    setupNameCapitalization: function() {
      var self = this;
      ['exitFirstName', 'exitLastName'].forEach(function(id) {
        var input = self.$(id);
        if (input) {
          input.addEventListener('input', function() {
            var start = input.selectionStart;
            var end = input.selectionEnd;
            input.value = self.capitalize(input.value);
            input.setSelectionRange(start, end);
          });
        }
      });
    },

    showPopup: function() {
      console.log('[Exit Popup] showPopup() called');
      var overlay = this.$('exit-popup-overlay');
      console.log('[Exit Popup] overlay element:', overlay);
      if (overlay) {
        overlay.style.display = 'flex';
        document.body.classList.add('popup-open');
        this.state.shown = true;
        this.markShown();
        console.log('[Exit Popup] POPUP NOW VISIBLE — overlay display set to flex');
        console.log('[Exit Popup] overlay computed display:', window.getComputedStyle(overlay).display);
        console.log('[Exit Popup] overlay computed z-index:', window.getComputedStyle(overlay).zIndex);
      } else {
        console.log('[Exit Popup] ERROR — overlay element not found!');
      }
    },

    hidePopup: function() {
      var overlay = this.$('exit-popup-overlay');
      if (overlay) {
        overlay.style.display = 'none';
        document.body.classList.remove('popup-open');
      }
    },

    validateForm: function() {
      var valid = true;
      var firstInvalid = null;

      // Check user type
      if (!this.state.userType) {
        var err = this.$('exit-popup-type-error');
        if (err) err.style.display = 'block';
        valid = false;
      }

      var fields = ['exitFirstName', 'exitLastName', 'exitEmail', 'exitCountry'];
      var self = this;
      fields.forEach(function(id) {
        var field = self.$(id);
        if (!field) return;
        var label = field.previousElementSibling;
        field.classList.remove('is-invalid');
        if (label) label.classList.remove('is-invalid');

        if (!field.value || !field.value.trim()) {
          valid = false;
          field.classList.add('is-invalid');
          if (label) label.classList.add('is-invalid');
          if (!firstInvalid) firstInvalid = field;
        }

        if (id === 'exitEmail' && field.value && field.value.trim()) {
          var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!re.test(field.value)) {
            valid = false;
            field.classList.add('is-invalid');
            if (label) label.classList.add('is-invalid');
            if (!firstInvalid) firstInvalid = field;
          }
        }
      });

      if (!valid && firstInvalid) {
        firstInvalid.focus();
      }

      return valid;
    },

    handleSubmit: function(e) {
      e.preventDefault();
      if (!this.validateForm()) return;

      var self = this;
      var submitBtn = this.$('exit-popup-form').querySelector('button[type="submit"]');
      var originalText = submitBtn.textContent;
      var errorHolder = this.$('exit-popup-error');

      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing...';
      if (errorHolder) errorHolder.style.display = 'none';

      var formData = {
        action: 'exit-popup',
        brand: CONFIG.BRAND,
        type: this.state.userType,
        firstName: this.$('exitFirstName').value,
        lastName: this.$('exitLastName').value,
        email: this.$('exitEmail').value,
        country: this.$('exitCountry').value,
      };

      fetch(CONFIG.API_BASE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
      .then(function(response) {
        return response.json().then(function(result) {
          if (!response.ok) throw new Error(result.error || 'An unexpected error occurred.');
          return result;
        });
      })
      .then(function() {
        // Trigger PDF download
        var pdfUrl = self.$('exit-popup-overlay').getAttribute('data-pdf-url');
        if (pdfUrl) {
          var a = document.createElement('a');
          a.href = pdfUrl;
          a.download = '';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }

        // Show success view
        var formView = self.$('exit-popup-form-view');
        var successView = self.$('exit-popup-success-view');
        if (formView) formView.style.display = 'none';
        if (successView) successView.style.display = 'flex';
      })
      .catch(function(error) {
        console.error('[Exit Popup] Submission error:', error);
        if (errorHolder) {
          errorHolder.textContent = error.message;
          errorHolder.style.display = 'block';
        }
      })
      .then(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      });
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { ExitPopupManager.init(); });
  } else {
    ExitPopupManager.init();
  }
})();
